import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';

interface BelowTabSelectBoxProps extends HTMLAttributes<HTMLDivElement> {
  iconType?: IconType;
}

export function BelowTabSelectBox({
  iconType = IconType.TabSorting,
  children,
  className,
  ...props
}: BelowTabSelectBoxProps) {
  return (
    <div
      className={twMerge(
        'flex shrink-0 cursor-pointer select-none items-center justify-center space-x-4pxr',
        className
      )}
      {...props}
    >
      {/* TODO: @ray.donghyuk 검색 결과 페이지는 sorting 디자인 변경 나중에 적용함그때 조건 제거 */}
      {iconType !== IconType.TabArrowDown && (
        <Icon type={iconType} disableActiveEffect />
      )}
      <Text
        className={twMerge(
          'font-small2 text-theme-solid-100',
          iconType === IconType.ContentHomeFilter &&
            'font-small2-bold text-theme-solid-60'
        )}
      >
        {children}
      </Text>
      {/*
        TODO: @ray.donghyuk 검색 결과 페이지까지 sorting 디자인 변경되면
        아이콘은 이제 뒤로 붙지 않음. 그때는 아래 아이콘 jsx 모두 제거
      */}
      {iconType === IconType.TabArrowDown && (
        <Icon type={iconType} disableActiveEffect />
      )}
    </div>
  );
}

export const BelowTabSelectBoxType = (<BelowTabSelectBox />).type;
